export const sanitizeId = (raw) => {
  return String(raw ?? "").trim().replace(/^\/+|\/+$/g, "");
};